import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moreContent", "googlePlaceIdInput", "nameInput", "lngInput", "latInput", "addressInput", "zipCodeInput", "cityInput", "countryCodeInput"]
  static outlets = ["form--google-autocomplete-input"]

  /**
   * Override selectGooglePlace and selectDefaultSuggestion to handle the
   * selection of a Google Place and the default suggestion in the Google Autocomplete Input.
  **/
  formGoogleAutocompleteInputOutletConnected(outlet, element) {
    outlet.selectGooglePlace = this.selectGooglePlace.bind(this)
    outlet.selectPersistedItem = this.establishmentNotFound.bind(this)
  }

  establishmentNotFound(item) {
    this.formGoogleAutocompleteInputOutlet.inputTarget.value = item.dataset.inputValue
    this.formGoogleAutocompleteInputOutlet.inputTarget.setAttribute("value", item.dataset.inputValue)

    this.formGoogleAutocompleteInputOutlet.closeSuggestionDropdown()
    this.formGoogleAutocompleteInputOutlet.inputTarget.blur()

    this.googlePlaceIdInputTarget.value = "not_found"
    this.moreContentTarget.classList.remove("d-none")
    this.nameInputTarget.focus()
  }

  selectGooglePlace(placeData) {
    this.placeData = placeData
    this.formGoogleAutocompleteInputOutlet.inputTarget.value = this.placeData.name
    this.fillFormInputsWithPlaceData()
    this.moreContentTarget.classList.remove("d-none")
  }

  fillFormInputsWithPlaceData() {
    this.zipCodeInputTarget.value = this.findAddressComponent("postal_code")?.long_name || null
    this.cityInputTarget.value = this.findAddressComponent("locality")?.long_name || null
    this.countryCodeInputTarget.value = this.findAddressComponent("country")?.short_name || null
    this.googlePlaceIdInputTarget.value = this.placeData.place_id
    this.latInputTarget.value = this.placeData.geometry.location.lat()
    this.lngInputTarget.value = this.placeData.geometry.location.lng()
    this.nameInputTarget.value = this.placeData.name
    this.addressInputTarget.value = this.formattedAddress()
  }

  formattedAddress() {
    const streetNumber = this.findAddressComponent("street_number")?.long_name || ""
    const route = this.findAddressComponent("route")?.long_name || ""
    return `${streetNumber} ${route}`.trim()
  }

  findAddressComponent(type) {
    const component = this.placeData.address_components?.find(c => c.types.includes(type))
    return component
  }
}
